'use strict';

angular.module('atex.aceui.service').factory('FileDeliveryService',
['$q', '$rootScope', 'ApplicationConfigurationService', 'AuthenticationService',

  function($q, $rootScope, ApplicationConfigurationService, AuthenticationService) {
    var serviceHandler = undefined;

    var handler = function() {
      if (serviceHandler !== undefined) {
        return $q.when(serviceHandler);
      }

      return ApplicationConfigurationService.getServiceConfigurationFor('FileDeliveryService').then(function(configuration) {
        var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'filedelivery');

        var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope) };
        serviceHandler = atex.aceui.service.FileDeliveryService(serviceUrl, serviceSettings);

        return serviceHandler;
      });
    };

    return {
      /**
       * Returns a file delivery service base url for the content represented by the given alias.
       *
       * @param {string} alias - the alias of the content to get the base url for
       *
       * @see atex.aceui.service.FileDeliveryService
       *
       * @returns {Promise.<{string}, atex.aceui.error.Error>} - the content base URL
       */
      getContentBaseUrl: function(alias) {
        return handler().then(function(serviceHandler) {
          return serviceHandler.getContentBaseUrl(alias);
        });
      },

      /**
       * Returns a file delivery service base url for the content version represented by the given version.
       *
       * @param {string} version - the version of the content to get the base url for
       *
       * @see atex.aceui.service.FileDeliveryService
       *
       * @returns {Promise.<{string}, atex.aceui.error.Error>} - the content base URL
       */
      getContentVersionBaseUrl: function(version) {
        return handler().then(function(serviceHandler) {
          return serviceHandler.getContentVersionBaseUrl(version);
        });
      },

      /**
       * Returns the content of the file (as text) represented by the alias and fileName properties
       * of the given input object. Wraps the request with an authentication guard.
       *
       * @param {Object} transferInfo - a transfer info object containing request details
       * @param {string} transferInfo.alias - the alias of the content to retrieve the file from
       * @param {string] transferInfo.fileName - the file name of the file to retrieve
       *
       * @typedef {Object} TextFileResult - an object containing the result of the file request
       * @property {string} text - the content of the retrieved file
       *
       * @see atex.aceui.service.FileDeliveryService
       * @see AuthenticationService
       *
       * @returns {Promise.<TextFileResult, atex.aceui.error.Error>}
       */
      getTextFile: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return handler().then(function(serviceHandler) {
            return serviceHandler.getTextFile(_.extend(transferInfo, { authToken: currentUser.token }));
          });
        })
      }
    };
  }
]);
